/* lua.js generated code 0.3.0 */

var ButtonPushBounceAnim = require("clover/panel/component/common/uiButtonAnims/PushBounceAnim")
var BagItemList = require("clover/panel/component/bagpanel/BagItemList")
var BagHelpPanel = require("clover/panel/component/bagpanel/BagHelpPanel")
var PropBagPanel = xClass("PropBagPanel", BasePanel, function () {
    return cc.CSLoader.createNode("cocos/bag_bag_main_nolable.csb")
})
PropBagPanel.show = function () {
    function success() {
        let panel = PropBagPanel.create()
        panel.fitResolution()
        panel.popup(true)
    }
        // "font/zzgftongxin_40.fnt",
    // "font/zzgftongxin_40.fnt",
    preloadWithLoading(["packed/PropBagPanelRes.pack","font/zzgftongxin_40.fnt"], success, function () {
        Toast.make(getText("error.tip.load_res_error"))
    }, function () {
        Toast.make(getText("error.tip.load_canceled"))
    })
}
PropBagPanel.prototype.init = function () {
    var self = this
    FrameLoader.loadImageWithPlist("cocos/properties.plist")
    BasePanel.prototype.init.call(self)
    var close = UIGroupButton.create(self.getChildByName("com_close"))
    close.on(UIButtonEvent.Click, function () {
        self.onClose()
    })
    //TODO:这玩意app版本有个closecallback
    ButtonPushBounceAnim.create(close)

	var questionBtn = UIGroupButton.create(self.getChildByName("bag_info"))
	questionBtn.on(UIButtonEvent.Click, function(){
			self.onQuestion()
    })
	ButtonPushBounceAnim.create(questionBtn)
	let sample = self.getChildByName("slide")
	sample.getChildByName("classify1").setVisible(false)
	sample.getChildByName("row").setVisible(false)

	var [bgX, bgY] = [0, 0]
	var bgSize = sample.getContentSize()
	self.itemList = {}
	let empty = self.getChildByName("empty_daoju")
	empty.getChildByName("txt").setTextHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER)
	empty.setVisible(false)
	let itemList = BagItemList.create(1, self, empty)
	itemList.setAnchorPoint(0.5, 0.5)
	itemList.setPosition(cc.p(bgX, bgY))
	itemList.setContentSize(bgSize.width, bgSize.height)
	itemList.init()
	self.getChildByName("slide").addChild(itemList)
	self.itemList[1] = itemList

    DCAssist.dc4OpenModule(ModuleName.BAG)
	self.showTab(1)
}
PropBagPanel.prototype.showTab = function (tab) {
    for (var i = 0; i < this.itemList.length; ++i){
        this.itemList[i].setVisible(i==tab)
        if (i == tab){
            this.itemList[i].refreshItemList()
        }
    }
    
    let isValid =  function ( itemId ){
        for (var k in GamePropIds) {
            var v = GamePropIds[k]
            if (itemId === v) {
                return true
            }
        }
    }

    const now = new Date().getTime();
    let getMinutes = function(expireTime) {
        let time = Math.floor((expireTime - now) / 1000 / 60);
        return time;
    }

    //--打点
    var name, t1, t2, t3
    if (tab == 1){
        name = "item"
        t1 = ""
        t2 = ""
        t3 = ""
        pf = ""
        let timeProps = UserManager.getInstance().getAndUpdateTimeProps()
        for (var k in timeProps) {
            let curProp = timeProps[k]
            if (curProp.num > 0 && isValid(curProp.itemId)){
                if (UserPropData.isBagInfiniteProp(curProp.itemId)){
                    pf = pf + tostring(curProp.itemId) + "_" + getMinutes(curProp.expireTime)+";"
                }else if(UserPropData.isLitmitedPreProp(curProp.itemId)) {
                    const str = tostring(curProp.itemId) + "_" + getMinutes(curProp.expireTime)+";";
                    for(let i = 0;i < curProp.num;i++) {
                        t1 += str;
                    }
                }else{
                    t2 = t2 + tostring(curProp.itemId) + "_" + tostring(curProp.num) + ";"
                }
            }
        }
        
        let propRefs = UserManager.getInstance().getPropRef()
        for (var k in propRefs) {
            let curProp = propRefs[k]
            if (curProp.getNum() > 0 && isValid(curProp.itemId)) {
                t3 = t3 + tostring(curProp.itemId) + "_" + tostring(curProp.getNum()) + ";"
            }
        }
    }
    let session = DCAssist.dc4BagTabShow(name, pf, t1, t2, t3)
    if (this.dcSession == null) {
        this.dcSession = session
    }
    else{
        DCAssist.dc4BagClick(this.dcSession, name)
    }
}

PropBagPanel.prototype.onCleanup = function () {
    ResManager.release(["packed/PropBagPanelRes.pack"])
}
PropBagPanel.prototype.onQuestion = function () {
    if (this.isBusy || this.isClosed){
        return
    }
	DCAssist.dc4BagClick(this.dcSession, "note")
	DCAssist.dc4BagNoteShow(this.dcSession)
    //TODO isbusy逻辑回头加到helppanel里s
    let panel = BagHelpPanel.create()
    panel.popup()

}
PropBagPanel.prototype.onClose = function () {
    if (this.isBusy || this.isClosed){
        return
    }
	this.isBusy = true
	DCAssist.dc4BagClick(this.dcSession, "close")
    BasePanel.prototype.onClose.call(this)
}
module.exports = PropBagPanel
